import parseSrc from 'parse-srcset'
import { desc } from '@util/sort'


export const htmlFields = page => {

	// get all image options to use in open graph tags

	const mediaFields = [
		page?.acf?.thumb_media,
		page?.acf?.list_media,
		page?.acf?.background_media,
	]

	const mediaOptions = mediaFields
		.filter(fields => fields?.format === 'image')
		.map(fields => mediaProps(fields))

	const imageOptions = [
		page?.acf.og_image,
		...mediaOptions,
		page?.acf.image_background,
		page?.og_image_default,
	].filter(props => props?.src)

	const first = imageOptions[0] ?? {}
	
	// parse the srcset attribute, and grab the first at 1000px or below

	const ogImageSizes = parseSrc(first.srcset || '')
		.sort((a, b) => desc(a.w, b.w))

	const selected = ogImageSizes.reduce((selected, image) => {
		if (selected) return selected
		if (image.w <= 1000) return image
	}, undefined)

	const selectedWidth = selected?.w || undefined
	const selectedSrc = selected?.url || undefined	

	// basic props

	return {
		title: page?.title_raw,
		description: page?.acf?.og_description,
		color: page?.acf?.background_colour_main || undefined,
		colorDark: page?.acf?.background_colour_feature || undefined,
		siteTitle: page?.site_title || undefined,
		siteTagline: page?.site_tagline || undefined,
		image: selected && {
			src : selectedSrc,
			width : selectedWidth,
			height : Math.floor(selectedWidth / first.width * first.height)
		},
		noIndex: page?.acf?.hide_in_sitemap || undefined
	}
}

export const heroFields = page => {
	const fields = page?.acf
	const background = fields?.background_media
	const props = mediaProps(background)
	const isImage = (background?.format === 'image')
	const isVideo = (background?.format === 'video')
	return {
		title: fields?.title || page?.title_raw || undefined,
		subtitle: fields?.subtitle || undefined,
		fade : !(fields?.remove_transparency),
		image: isImage ? props : undefined,
		video : isVideo ? props : undefined
	}
}


export const mediaProps = field => {
	if (!field?.format) return undefined
	if (field.format === 'image') {
		var props = field.image
		var edit = field.image_centre_point ?? false
		var x = field.image_x ?? 50
		var y = field.image_y ?? 50
	} else if (field.format === 'video') {
		var props = { src: field.video_file_url	}
		var edit = field.video_centre_point ?? false
		var x = field.video_x ?? 50
		var y = field.video_y ?? 50
	}
	if (!props.src) return undefined
	const position = `${x}% ${y}%`
	if (edit) props.style = { objectPosition : position }
	return props
}

export const imageProps = data => {
	const props = data?.image_background || data?.image?.image_background || {}
	const edit = data.edit_focal_point ?? false
	const x = data.image_x ?? 50
	const y = data.image_y ?? 50
	const position = `${x}% ${y}%`;

	if (!props.src) return undefined
	props.style = edit ? {
		backgroundPosition: position,
		objectPosition: position
	} : {}
	return props;
}

export const workMediaInfo = (page) => {
	const backgroundProps = mediaProps(page.acf.background_media)
	const listBackgroundProps = mediaProps(page.acf.list_media)
	const backgroundFields = backgroundProps && page.acf.background_media
	const listBackgroundFields = listBackgroundProps && page.acf.list_media
	const props = listBackgroundProps || backgroundProps
	const fields = listBackgroundFields || backgroundFields
	return { props, fields }
}

export const workThumbInfo = page => {
	const backgroundProps = mediaProps(page.acf.background_media)
	const thumbBackgroundProps = mediaProps(page.acf.thumb_media)
	const backgroundFields = backgroundProps && page.acf.background_media
	const thumbBackgroundFields = thumbBackgroundProps && page.acf.thumb_media
	const props = thumbBackgroundProps || backgroundProps
	const fields = thumbBackgroundFields || backgroundFields
	return { props, fields }
}